export default "__VITE_PUBLIC_ASSET__a91f1c3d__"